import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../contexts/ToastContext';
import { useCart } from '../contexts/CartContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { orderService } from '../services/orderService';
import { formatPrice } from '../utils/priceHelpers';
import { config } from '../utils/config';

const CheckoutLocal = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const toast = useToast();
  const { items, subtotal, clearCart } = useCart();
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('Kinshasa');
  const [phone, setPhone] = useState(user?.phone || '');
  const [paymentMethod, setPaymentMethod] = useState('cash_on_delivery');
  const [processing, setProcessing] = useState(false);

  const deliveryFee = config.LOCAL_DELIVERY_FEE;
  const total = subtotal + deliveryFee;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!items.length) {
      toast.warning('Panier vide');
      navigate('/shop');
      return;
    }
    if (!address.trim()) {
      toast.warning('Indiquez une adresse de livraison');
      return;
    }

    setProcessing(true);
    try {
      const result = await orderService.createLocalOrder({
        cartItems: items,
        deliveryAddress: {
          line1: address.trim(),
          city: city.trim(),
          phone: phone.trim(),
        },
        deliveryFee,
        paymentMethod,
      });

      if (result.success) {
        clearCart();
        if (paymentMethod === 'cash_on_delivery') {
          toast.success('Commande confirmée — paiement à la livraison');
          navigate('/dashboard');
        } else {
          toast.success('Commande créée — procédez au paiement');
          navigate(`/payment/${result.order.id}`);
        }
      } else {
        toast.error(result.error || 'Erreur lors de la commande');
      }
    } catch (err) {
      toast.error('Erreur inattendue');
    } finally {
      setProcessing(false);
    }
  };

  if (!items.length) {
    navigate('/cart');
    return null;
  }

  return (
    <div>
      <Navbar />
      <div className="container" style={{ padding: '30px 20px', maxWidth: 560 }}>
        <h1 style={{ marginBottom: 8 }}>Finaliser la commande</h1>
        <p style={{ color: '#666', marginBottom: 24 }}>
          Boutique locale — payez en ligne ou à la livraison.
        </p>

        <div className="card" style={{ padding: 16, marginBottom: 24 }}>
          <p>
            <strong>{items.length}</strong> article(s) — Total{' '}
            <strong style={{ color: '#FF0000' }}>{formatPrice(total)}</strong>
          </p>
        </div>

        <form onSubmit={handleSubmit} className="card" style={{ padding: 24 }}>
          <div className="form-group">
            <label htmlFor="address">Adresse de livraison *</label>
            <input
              id="address"
              required
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              placeholder="Avenue, quartier, commune…"
            />
          </div>
          <div className="form-group">
            <label htmlFor="city">Ville</label>
            <input id="city" value={city} onChange={(e) => setCity(e.target.value)} />
          </div>
          <div className="form-group">
            <label htmlFor="phone">Téléphone de contact</label>
            <input
              id="phone"
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="243900000000"
            />
          </div>

          <div className="form-group">
            <label style={{ marginBottom: 12, display: 'block' }}>Mode de paiement *</label>
            <label
              style={{
                display: 'flex',
                gap: 12,
                alignItems: 'flex-start',
                padding: 14,
                marginBottom: 10,
                border: `2px solid ${paymentMethod === 'cash_on_delivery' ? '#28a745' : '#ddd'}`,
                borderRadius: 8,
                cursor: 'pointer',
                background: paymentMethod === 'cash_on_delivery' ? '#f0fff4' : '#fff',
              }}
            >
              <input
                type="radio"
                name="paymentMethod"
                value="cash_on_delivery"
                checked={paymentMethod === 'cash_on_delivery'}
                onChange={() => setPaymentMethod('cash_on_delivery')}
                style={{ marginTop: 4 }}
              />
              <div>
                <strong>Paiement à la livraison</strong>
                <p style={{ margin: '4px 0 0', fontSize: 13, color: '#666' }}>
                  Payez en espèces ou Mobile Money au livreur à la réception.
                </p>
              </div>
            </label>
            <label
              style={{
                display: 'flex',
                gap: 12,
                alignItems: 'flex-start',
                padding: 14,
                border: `2px solid ${paymentMethod === 'online' ? '#FF0000' : '#ddd'}`,
                borderRadius: 8,
                cursor: 'pointer',
                background: paymentMethod === 'online' ? '#fff5f5' : '#fff',
              }}
            >
              <input
                type="radio"
                name="paymentMethod"
                value="online"
                checked={paymentMethod === 'online'}
                onChange={() => setPaymentMethod('online')}
                style={{ marginTop: 4 }}
              />
              <div>
                <strong>Payer maintenant (Mobile Money)</strong>
                <p style={{ margin: '4px 0 0', fontSize: 13, color: '#666' }}>
                  Orange, Airtel, M-Pesa ou Afrimoney via SerdiPay.
                </p>
              </div>
            </label>
          </div>

          <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={processing}>
            {processing
              ? 'Création…'
              : paymentMethod === 'cash_on_delivery'
                ? 'Confirmer — paiement à la livraison'
                : 'Confirmer et payer'}
          </button>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default CheckoutLocal;
